import { Link } from "react-router-dom";
import { openPopup } from "../../store/popupSlice"
import { useDispatch } from "react-redux";

export default function Landing2Go() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="landing2-go">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-7 col-md-7">
              <div className="land2-go-head">
                <h2 className="heading gradiant-color">Why Pick a White Label Taxi dispatch Solution?</h2>
                <span>Your Brand, Our Technology—A Winning Combination</span>
                <p>Skip the hassle of building from scratch. Our white-label taxi dispatch solution delivers a fully production-ready platform that seamlessly integrates with your brand, logo, colors, and domain. Upgrade your fleet operations with a powerful Taxi Dispatch Software Solution, featuring real-time tracking, automation, and flexible subscriptions. Focus on scaling your taxi business while we handle the technical complexities.</p>
                <Link onClick={() => dispatch(openPopup())} className="default-btn">get started</Link>
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <div className="land2-go-img">
                <img loading="lazy" src="/assets/home/land2-go.webp" alt="whitelabel" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-12">
              <div className="land2-go-rider">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="land2-rider-box">
                      <img loading="lazy" src="assets/home/land2-rider-1.webp" alt="icon" className="img-responsive" />
                      <div>
                        <h3>Rider & Driver Apps</h3>
                        <p>Branded Android and iOS apps with seamless onboarding, intuitive UI, ride booking, trip tracking, and essential features.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="land2-rider-box">
                      <img loading="lazy" src="assets/home/land2-rider-2.webp" alt="icon" className="img-responsive" />
                      <div>
                        <h3>Real-Time Tracking</h3>
                        <p>Monitor trips live to enhance passenger safety, operational efficiency, and real-time transparency for customers.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="land2-rider-box">
                      <img loading="lazy" src="assets/home/land2-rider-3.webp" alt="icon" className="img-responsive" />
                      <div>
                        <h3>In-App Notifications</h3>
                        <p>Keep users engaged with real-time alerts about ride confirmations, driver arrival, and other essential updates.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="land2-rider-box">
                      <img loading="lazy" src="assets/home/land2-rider-4.webp" alt="icon" className="img-responsive" />
                      <div>
                        <h3>Payment Gateway Integration</h3>
                        <p>Securely accept payments via cards, wallets, and cash with seamless integration of trusted payment gateways.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="land2-rider-box">
                      <img loading="lazy" src="assets/home/land2-rider-5.webp" alt="icon" className="img-responsive" />
                      <div>
                        <h3>Auto & Manual Dispatching</h3>
                        <p>Assign the nearest driver automatically or manually dispatch for scheduled trips, ensuring flexible ride management.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="land2-rider-box">
                      <img loading="lazy" src="assets/home/land2-rider-6.webp" alt="icon" className="img-responsive" />
                      <div>
                        <h3>Admin Dashboard & Analytics</h3>
                        <p>Track revenue, trip volumes, user activity, and driver performance with advanced analytics for data-driven decisions.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="land2-rider-butn text-center">
                      <button onClick={() => dispatch(openPopup())} className="default-btn">Schedule a free Demo</button>
                      <Link to={"/features/taxi-software"}><button className="default-white ">Explore More</button></Link>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
    </>
  )
}
